/* Minimal modal open/close wiring (jQuery).

   Markup contract (used by user/role list pages):
     <button data-modal-open="user-add">...</button>
     <div id="modal-user-add" data-modal class="hidden ...">...</div>
     <button data-modal-close>X</button>   (inside the modal)

   Behavior:
     - Clicking a [data-modal-open="foo"] shows #modal-foo
     - Clicking [data-modal-close] closes the enclosing modal
     - Clicking the backdrop (the [data-modal] element itself) closes it
     - Esc closes the topmost open modal
*/
(function ($) {
  // ---------- Theme toggle ----------
  // The initial class on <html> is applied by an inline script in _master.html
  // BEFORE first paint; this handler only flips it on click and persists.
  $(document).on('click', '[data-theme-toggle]', function () {
    var $html = $(document.documentElement);
    var toDark = !$html.hasClass('dark');
    $html.toggleClass('dark', toDark);
    try {
      localStorage.setItem('theme', toDark ? 'dark' : 'light');
    } catch (e) {}
  });

  // ---------- Modals ----------
  function showModal($el) {
    $el.removeClass('hidden').addClass('flex');
  }
  function hideModal($el) {
    $el.addClass('hidden').removeClass('flex');
  }

  $(document).on('click', '[data-modal-open]', function (e) {
    e.preventDefault();
    var id = '#modal-' + $(this).data('modal-open');
    showModal($(id));
  });

  $(document).on('click', '[data-modal-close]', function () {
    hideModal($(this).closest('[data-modal]'));
  });

  // Backdrop click (only when the click target IS the modal wrapper, not a child).
  $(document).on('click', '[data-modal]', function (e) {
    if (e.target === this) hideModal($(this));
  });

  $(document).on('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var $open = $('[data-modal]:not(.hidden)').last();
    if ($open.length) hideModal($open);
  });

  // ---------- Shutdown countdown ticker ----------
  // Renders 'in 4h 23m' / 'in 12m' / 'now' inside any element matching:
  //   .row-shutdown-countdown          (devices list cell)
  //   #connect-shutdown-countdown      (connect page top bar)
  // Both have a `data-fire-at` ISO-8601 attribute (empty if no pending shutdown).
  // The inner `.countdown-value` span gets the rendered text.
  //
  // Ticks every 30s -- a 60s tick would let "in 1m" stay visible after the
  // shutdown already fired.
  function fmtRemaining(ms) {
    if (ms <= 0) return 'now';
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    if (h > 0) return 'in ' + h + 'h ' + m + 'm';
    if (m > 0) return 'in ' + m + 'm';
    return 'in <1m';
  }
  function tickCountdowns() {
    var now = Date.now();
    $('[data-fire-at]').each(function () {
      var fireAt = $(this).attr('data-fire-at');
      var $val = $(this).find('.countdown-value');
      if (!fireAt) {
        // No pending shutdown -- hide the badge entirely.
        $(this).addClass('hidden');
        return;
      }
      var t = Date.parse(fireAt);
      if (isNaN(t)) return;
      $(this).removeClass('hidden');
      $val.text(fmtRemaining(t - now));
    });
  }
  // Expose so other scripts can force a re-render after server pushes.
  window.tickShutdownCountdowns = tickCountdowns;
  $(function () {
    tickCountdowns();
    setInterval(tickCountdowns, 30000);
  });
})(jQuery);